import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-remix': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7zM410.1 260.4L415 262.6V332.6C407.8 336.2 351.6 360.1 347.7 361.4 341.2 359.6 234 314.6 210.4 305.2L146.2 331.8 82.9 304.3V240.5L142.2 215.7C141.5 215 141.8 220.7 141.8 145.3L209.1 115.6 361 178.5V240.1L410.1 260.4zM339.7 341.9V298.1H339.3V296.3L225.5 249.8V295L339.3 341.9V341.5L339.7 341.9zM347.2 284.3L387.1 267.9 350.3 252.4 311.3 268.8 347.2 284.3zM399.5 322.4V279.4L355.2 298V341.4L399.5 322.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-remix.js
// module id = nx1X
// module chunks = 144